import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { Divider } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from '../../../src/i18n';
import Button from '../../Button';
import { TP } from '../../../constants/consts';
import { colors } from '../../../constants/styleConstants';
import TitleBlock from '../TitleBlock';
import NoListItems from '../../NoListItems';

const useStyles = makeStyles(theme => ({
  titleSection: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginBottom: theme.spacing(1),
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  section: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const EditMediaLayout = ({
  className,
  title,
  subtitle,
  children,
  buttonTitle,
  addButtonClick,
  isEmpty,
  emptyMessage,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={cn(classes.root, className)}>
      <div className={classes.titleSection}>
        <TitleBlock title={title} subtitle={subtitle} />
        {addButtonClick && (
          <Button
            onClick={addButtonClick}
            color="default"
            variant="outlined"
            endIcon={<AddIcon style={{ color: colors.blue }} />}
          >
            {t(buttonTitle)}
          </Button>
        )}
      </div>
      <Divider />
      {isEmpty ? <NoListItems text={t(emptyMessage)} /> : <section className={classes.section}>{children}</section>}
    </div>
  );
};

EditMediaLayout.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  buttonTitle: PropTypes.string,
  addButtonClick: PropTypes.func,
  isEmpty: PropTypes.bool,
  emptyMessage: PropTypes.string,
};

EditMediaLayout.defaultProps = {
  title: '',
  subtitle: '',
  buttonTitle: `${TP}.m_ADD`,
  addButtonClick: () => {},
  isEmpty: false,
  emptyMessage: `${TP}.FN_NO_ITEMS`,
};

export default memo(EditMediaLayout);
